const TOKENS_PER_MESSAGE = 3;
const PRIMER_TOKENS = 3;
const TOKENS_PER_WORD = 1;
const CHARS_PER_TOKEN = 4;
const LONG_WORD_THRESHOLD = 15;

const estimateTextTokens = (text) => {
  if (!text) {
    return 0;
  }
  const words = text.split(/\s+/).filter(Boolean);
  let tokens = 0;
  for (const word of words) {
    tokens +=
      word.length > LONG_WORD_THRESHOLD
        ? word.length / CHARS_PER_TOKEN
        : TOKENS_PER_WORD;
  }
  return Math.ceil(tokens);
};

/**
 * Estimates the token count for a list of chat messages using a lightweight
 * word-based heuristic (~1 token per word). This is used for live display
 * during typing; accurate server-reported counts replace this after generation.
 * @param {Array<Object>} messages - An array of message objects (e.g., [{ role: 'user', content: '...' }]).
 * @returns {number} The estimated number of tokens.
 */
export const countChatTokens = (messages) => {
  if (!messages?.length) {
    return 0;
  }

  let tokens = PRIMER_TOKENS;
  for (const msg of messages) {
    tokens += TOKENS_PER_MESSAGE;
    tokens += estimateTextTokens(msg.role);
    tokens += estimateTextTokens(msg.content);
  }

  return Math.ceil(tokens);
};
